import { render, staticRenderFns } from "./ClientesLevados.vue?vue&type=template&id=48ac2da4"
import script from "./ClientesLevados.vue?vue&type=script&lang=js"
export * from "./ClientesLevados.vue?vue&type=script&lang=js"
import style0 from "./ClientesLevados.vue?vue&type=style&index=0&id=48ac2da4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports